/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { DUNNING_DIALOG_DISMISSED } from "@nf/constants";
import * as Consts from "./consts";
import { CoreActionsTypes, ICoreState } from "./types";
import { StorageManager } from "../../services";

export const initialState: ICoreState = {
  wasDunningDialogDismissed: StorageManager.getValueSync(
    DUNNING_DIALOG_DISMISSED
  ),
};

export const coreReducer = (
  state = initialState,
  action: CoreActionsTypes
): ICoreState => {
  switch (action.type) {
    case Consts.SET_APP_GLOBAL_ERROR: {
      return {
        ...state,
        globalError: action.payload,
      };
    }
    case Consts.SET_DUNNING_DIALOG_DISMISSED: {
      return {
        ...state,
        wasDunningDialogDismissed: action.payload,
      };
    }
    default:
      return state;
  }
};
